import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';

export const menuStyles = makeStyles((theme: Theme) =>
    createStyles({
    '@global': {
        '*::-webkit-scrollbar': {
            width: '0.4em'
        },
        '*::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            outline: '1px solid slategrey'
        }
    },
    slide: {
        position: 'absolute',
        backgroundColor: 'rgba(87,87,86,0.98)',
        width: '40%',
        maxWidth: '450px',
        height: 'calc(100% - 54px)',
        // height: '100%',
        border: '1px solid rgb(78,78,77)',
        borderLeftWidth: '0',
        overflow: 'hidden',
        top: '52px',
        zIndex: theme.zIndex.drawer +1
    },
    slideMobile: {
        width: '100%',
        maxWidth: '100%',
        height: 'calc(100% - 48px)',
        top: '48px'
    },
    topSlide: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#575756',
        height: '50px',
        margin: '0 0 50px 0',
        boxShadow: '0px 1px 3px -2px rgba(0,0,0,0.12), 0px 1px 1px -1px rgba(0,0,0,0.08), 0px 2px 1px -1px rgba(0,0,0,0.06)',
    },
    close: {
        alignItems: 'center',
        display: 'flex',
        flexShrink: 0,
        outline: 'none',
        position: 'relative',
        cursor: 'pointer',
        transition: 'color 0.2s,background-color 0.2s,border-color 0.4s',
        color: '#FFFFFF',
        borderRight: '1px solid rgb(78,78,77)',
        minHeight: '50px',
        backgroundColor: '#575756',
        padding: '0 14px',
    },
    slideTitle: {
        margin: '0',
        display: 'block',
        fontWeight: 'normal',
        fontFamily: 'myriad-pro, sans-serif',
        fontSize: 'calc(14px * 1.2)',
        color: '#B0B0B1',
        letterSpacing: '0.025rem',
        padding: '0 calc(1 * 1em)',
    },
    slideContent: {
        display: 'flex',
        height: '100%',
        paddingLeft: '50px',
    },
    contentGroups: {
        width: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        marginBottom: '6rem',
    },
    groups: {
        maxHeight: '100%',
        marginRight: '-100px',
        paddingRight: '100px',
        paddingBottom: '15px',
    },
    groupTitle: {
        margin: '1em 0',
        display: 'block',
        fontWeight: 'bold',
        fontFamily: 'myriad-pro,sans-serif',
        fontSize: 'calc(14px * 1.2)',
        color: '#B0B0B1',
        lineHeight: '1',
        letterSpacing: '0.025rem',
        textAlign: 'left',
        paddingLeft: '5px'
    },
    groupContent: {
        display: 'flex',
        flexFlow: 'row wrap',
    }
}));